module.exports = __webpack_public_path__ + "static/media/guide_3.52a8b57e.png";